(function () {
  // Utilitaire: construit un Set des modèles existants pour une couleur
  function buildMaps(variants) {
    const modelsForColor = new Map(); // color => Set(models)
    variants.forEach(v => {
      const c = v.option1, m = v.option2;
      if (!c || !m) return;
      if (!modelsForColor.has(c)) modelsForColor.set(c, new Set());
      modelsForColor.get(c).add(m);
    });
    return { modelsForColor };
  }

  // Reconstruit les <option> du select "Modèle" selon la couleur
  function repopulateModelSelect(selectColor, selectModel, modelsSet) {
    const currentModel = selectModel.value;
    const models = Array.from(modelsSet || []);
    // garde l'étiquette/placeholder s’il y en a un en tête
    const placeholder = selectModel.querySelector('option[value=""]');
    selectModel.innerHTML = '';
    if (placeholder) selectModel.appendChild(placeholder);

    models.forEach(m => {
      const opt = document.createElement('option');
      opt.value = m; opt.textContent = m;
      selectModel.appendChild(opt);
    });

    // si l'ancien modèle est encore possible, on le remet, sinon on sélectionne le premier
    if (models.includes(currentModel)) {
      selectModel.value = currentModel;
    } else if (models.length) {
      selectModel.value = models[0];
    }
    // déclenche le change pour que le thème mette à jour la variante/stock/prix
    selectModel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function enhanceVariantBlock(block) {
    if (block.dataset.mrLinked === 'true') return;

    // Récupère le JSON des variantes dans le <script type="application/json"> du bloc
    const jsonScript = block.querySelector('script[type="application/json"]');
    if (!jsonScript) return;
    let variants;
    try { variants = JSON.parse(jsonScript.textContent.trim()); } catch(e){ return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const { modelsForColor } = buildMaps(variants);

    // Trouve les 2 selects (ordre: option1 = Couleur, option2 = Modèle)
    const selects = block.querySelectorAll('select.select__select');
    if (selects.length < 2) return;
    const selectColor = selects[0];
    const selectModel = selects[1];

    // Au chargement : filtre selon la couleur initiale
    const initColor = selectColor.value;
    if (initColor && modelsForColor.has(initColor)) {
      repopulateModelSelect(selectColor, selectModel, modelsForColor.get(initColor));
    }

    // Sur changement de couleur : reconstruit les choix modèle qui existent réellement
    selectColor.addEventListener('change', () => {
      const c = selectColor.value;
      const set = modelsForColor.get(c) || new Set();
      repopulateModelSelect(selectColor, selectModel, set);
    });

    block.dataset.mrLinked = 'true';
  }

  // Scan de tous les blocs variant-selects (page produit + quick add)
  function scan(root) {
    (root || document).querySelectorAll('variant-selects').forEach(enhanceVariantBlock);
  }

  document.addEventListener('DOMContentLoaded', () => scan(document));
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:reorder', e => scan(e.target));

  // Pour le Quick Add qui injecte du HTML dynamiquement
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      m.addedNodes && m.addedNodes.forEach(n => { if (n.nodeType === 1) scan(n); });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  const NEW_TEXT = 'Bientôt de retour !'; // <-- mets ton texte ici

  function updateSoldOutButtons(root = document) {
    // Cible large: boutons d’ajout au panier sur la fiche produit
    const buttons = root.querySelectorAll(
      'form[action*="/cart/add"] button[type="submit"], product-form button[type="submit"]'
    );

    buttons.forEach((btn) => {
      // On ne change que les boutons désactivés (= rupture)
      if (!btn.disabled && btn.getAttribute('aria-disabled') !== 'true') return;

      // Certains thèmes mettent le texte dans un span interne
      const textNode =
        btn.querySelector('[data-add-to-cart-text], .product-form__submit-label, span') || btn;

      // Si le texte contient "Rupture" / "Sold out" / "Indisponible", on remplace
      const current = (textNode.textContent || '').trim().toLowerCase();
      if (
        current.includes('rupture') ||
        current.includes('sold out') ||
        current.includes('indisponible')
      ) {
        textNode.textContent = NEW_TEXT;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => updateSoldOutButtons());

  // Shopify re-render (changement de variante, sections, etc.)
  const mo = new MutationObserver(() => updateSoldOutButtons());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
